export default __webpack_public_path__ + "static/media/mozart7.b6be3a11.png";